/*
 * HelloSpicy — Estimateur de frais de port (audit A8). Voir snippets/hs-estimateur-frais.
 * Tarifs réels Shopify ; en cas d'échec, le bloc de résultats reste masqué.
 */
(function () {
  'use strict';
  var CP_DEFAUT = { FR: '75001' };
  var enCours = null;

  function euros(prix) {
    var v = parseFloat(prix);
    if (isNaN(v)) return null;
    if (v === 0) return 'Offert';
    return v.toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function params(pays, cp) {
    return 'shipping_address%5Bcountry%5D=' + encodeURIComponent(pays) +
      '&shipping_address%5Bzip%5D=' + encodeURIComponent(cp || '') +
      '&shipping_address%5Bprovince%5D=';
  }

  function attendre(qs, essais) {
    return fetch('/cart/async_shipping_rates.json?' + qs, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 200) return r.json();
        if (r.status === 202 && essais > 0) {
          return new Promise(function (ok) { setTimeout(ok, 600); }).then(function () { return attendre(qs, essais - 1); });
        }
        throw new Error('HTTP ' + r.status);
      })
      .then(function (j) {
        if (j === null && essais > 0) {
          return new Promise(function (ok) { setTimeout(ok, 600); }).then(function () { return attendre(qs, essais - 1); });
        }
        if (!j || !Array.isArray(j.shipping_rates)) throw new Error('réponse invalide');
        return j.shipping_rates;
      });
  }

  function estimer(root) {
    var form = root.querySelector('[data-hs-estim-form]');
    var out = root.querySelector('[data-hs-estim-resultats]');
    var sel = form.querySelector('select[name="country"]');
    var opt = sel.options[sel.selectedIndex];
    var iso = opt ? opt.getAttribute('data-iso') : '';
    var pays = sel.value; // code ISO (ex. FR, BE) : accepté par l'API, contrairement au nom traduit
    var paysNom = opt ? opt.textContent : pays;
    var saisi = (form.querySelector('input[name="zip"]').value || '').trim();
    var cp = saisi || CP_DEFAUT[iso] || '';
    var ref = {};
    enCours = ref;
    out.setAttribute('aria-busy', 'true');

    var qs = params(pays, cp);
    return fetch('/cart/prepare_shipping_rates.json?' + qs, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (r.status !== 202 && r.status !== 200) throw new Error('HTTP ' + r.status); return attendre(qs, 12); })
      .then(function (rates) {
        if (enCours !== ref) return;
        var lignes = rates.map(function (t) {
          var p = euros(t.price);
          if (!p) return '';
          return '<li><span>' + esc(t.presentment_name || t.name) + '</span><strong>' + p + '</strong></li>';
        }).filter(Boolean);
        if (!lignes.length) throw new Error('aucun tarif');

        // Point relais : non exposé par l'API → gratuité selon le seuil du thème,
        // sinon tarif saisi dans les réglages du thème (hs_tarif_relais).
        if (iso === 'FR') {
          var seuil = parseInt(root.getAttribute('data-seuil-relais'), 10) || 0;
          var total = window.__hsCartTotal;
          if (seuil && typeof total === 'number') {
            var seuilTxt = (seuil % 100 === 0 ? String(seuil / 100) : (seuil / 100).toFixed(2).replace('.', ',')) + '\u00a0€';
            var tarif = (root.getAttribute('data-tarif-relais') || '').replace(/\s*€\s*$/, '').trim();
            lignes.unshift(total >= seuil
              ? '<li><span>Point relais</span><strong>Offert</strong></li>'
              : (tarif
                ? '<li><span>Point relais <span class="hs-estim__muted">(offert dès ' + seuilTxt + ')</span></span><strong>' + esc(tarif) + '\u00a0€</strong></li>'
                : '<li><span>Point relais</span><span class="hs-estim__muted">tarif affiché au paiement (offert dès ' + seuilTxt + ')</span></li>'));
          }
        }
        var lieu = saisi ? (esc(paysNom) + ' ' + esc(saisi)) : (iso === 'FR' ? 'France métropolitaine' : esc(paysNom));
        out.innerHTML = '<p class="hs-estim__lieu">Livraison vers : ' + lieu + '</p><ul class="hs-estim__liste">' + lignes.join('') + '</ul>';
        out.hidden = false;
      })
      .catch(function () {
        if (enCours !== ref) return;
        out.innerHTML = '';
        out.hidden = true; // En cas d'échec : rien plutôt qu'un montant faux.
      })
      .then(function () { out.removeAttribute('aria-busy'); });
  }

  function majPanier(root) {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        window.__hsCartTotal = c.total_price;
        root.hidden = c.item_count === 0;
        if (c.item_count > 0) return estimer(root);
      })
      .catch(function () {});
  }

  function init() {
    var root = document.querySelector('[data-hs-estimateur]');
    if (!root) return;
    root.querySelector('[data-hs-estim-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      estimer(root);
    });
    majPanier(root);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { majPanier(root); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
